<template>
  <v-container>
    Sales Report

    <!-- <SuccessDialog
      :status="dialogAdd"
      :text_color="text_color"
      :title="title"
      :message="message"
    /> -->
  </v-container>
</template>

<script>
// import SuccessDialog from "@/components/cards/SuccessDialog";
import api from "@/services/api";
import { server } from "../services/constants";

export default {
  mounted() {
    // this.$showLoader();
    setTimeout(() => {
      this.$hideLoader();
    }, 500);
  },
  components: {
    // SuccessDialog,
  },
  data() {
    return {
      isShowPassword: false,
      fullPage: true,
    };
  },
  methods: {},
  beforeCreate() {
    console.log("beforeCreate");
    this.$store.state.navMenu = true;
  },
};
</script>

<style></style>
